import { render, staticRenderFns } from "./evaluateList.vue?vue&type=template&id=4733a665&scoped=true&"
import script from "./evaluateList.vue?vue&type=script&lang=js&"
export * from "./evaluateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4733a665",
  null
  
)

export default component.exports